import {Controller} from "@hotwired/stimulus"
import {Modal} from "bootstrap"

export default class extends Controller {
    connect() {
        this.modal = new Modal(this.element)
        this.modal.show()
    }

    hideBeforeRender(event) {
        if (event.detail.newStream["target"] === "remote_modal_body") {
            // debugger;

            let modal = document.getElementById("remote_modal_body");
            let danger_class = modal.dataset.stream_enter_danger_class;
            modal.addEventListener('animationend', function (e) {
                e.target.classList.remove(danger_class);
            })
            modal.classList.add(danger_class);
        } else {
            if (this.isOpen()) {

                // event.preventDefault()
                this.modal.hide();
                // debugger;
                this.element.addEventListener('hidden.bs.modal', event.detail.resume);
                // console.log(event.target.templateElement.content.firstElementChild);
                let row = event.target.templateElement.content.firstElementChild;
                let flash_class = row.dataset.stream_enter_flash_class;
                row.addEventListener('animationend', function (e) {
                    e.target.classList.remove(flash_class);
                })
                row.classList.add(flash_class)
            }
        }
    }

    isOpen() {
        return this.element.classList.contains("show")
    }
}